import * as React from "react";
import SelectDictionaryItem from "../../common/select/SelectDictionaryItem";
import {connect} from "react-redux";
import {RootState} from "../../../../store/reducer/root/RootState";

class SelectMerchant extends SelectDictionaryItem {
	onInputChange(value: string) {
		this.props.onInputChange(value);
	}
}

function mapStateToProps(state: RootState) {
	return {
		items: state.merchant.merchants
	}
}

export default connect(mapStateToProps)(SelectMerchant)